module.exports = __webpack_public_path__ + "img/logo.6580a048.png";